{
  "HELP_CENTER": {
    "TITLE": "Centrum pomocy",
    "NEW_PAGE": {
      "DESCRIPTION": "Twórz portale centrum pomocy typu self-service dla swoich klientów. Pomóż im szybko znajdować odpowiedzi, bez czekania. Usprawnij obsługę zapytań, zwiększ efektywność agentów i podnieś jakość obsługi klienta.",
      "CREATE_PORTAL_BUTTON": "Utwórz portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Bez tytułu"
    },
    "HEADER": {
      "FILTER": "Filtruj według",
      "SORT": "Sortuj według",
      "LOCALE": "Język",
      "SETTINGS_BUTTON": "Ustawienia",
      "NEW_BUTTON": "Nowy artykuł",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Opublikowane",
        "DRAFT": "Draft",
        "ARCHIVED": "Zarchiwizowane"
      },
      "TITLES": {
        "ALL_ARTICLES": "Wszystkie artykuły",
        "MINE": "Moje artykuły",
        "DRAFT": "Artykuły Draft",
        "ARCHIVED": "Archiwalne artykuły"
      },
      "LOCALE_SELECT": {
        "TITLE": "Wybierz język",
        "PLACEHOLDER": "Wybierz język",
        "NO_RESULT": "Nie znaleziono języka",
        "SEARCH_PLACEHOLDER": "Szukaj języka"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Wszystkie artykuły",
      "PUBLISH_BUTTON": "Opublikuj",
      "MOVE_TO_ARCHIVE_BUTTON": "Przenieś do archiwum",
      "PREVIEW": "Podgląd",
      "ADD_TRANSLATION": "Dodaj tłumaczenie",
      "OPEN_SIDEBAR": "Otwórz panel boczny",
      "CLOSE_SIDEBAR": "Zamknij panel boczny",
      "SAVING": "Zapisywanie...",
      "SAVED": "Zapisano"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Prześlij obraz",
        "UPLOADING": "Przesyłanie...",
        "SUCCESS": "Obraz został pomyślnie przesłany",
        "ERROR": "Błąd podczas przesyłania obrazu",
        "UN_AUTHORIZED_ERROR": "Nie masz uprawnień do przesyłania obrazów",
        "ERROR_FILE_SIZE": "Rozmiar obrazu powinien być mniejszy niż {size}MB",
        "ERROR_FILE_FORMAT": "Format obrazu powinien być jpg, jpeg lub png",
        "ERROR_FILE_DIMENSIONS": "Wymiary obrazu powinny być mniejsze niż 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Wstaw kotwicę",
        "TITLE": "Wstaw kotwicę",
        "SUBMIT": "Wstaw",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Ustawienia artykułu",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategoria",
          "TITLE": "Wybierz kategorię",
          "PLACEHOLDER": "Wybierz kategorię",
          "NO_RESULT": "Brak znalezionych kategorii",
          "SEARCH_PLACEHOLDER": "Szukaj kategorii"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Wybierz autora",
          "PLACEHOLDER": "Wybierz autora",
          "NO_RESULT": "Brak znalezionych autorów",
          "SEARCH_PLACEHOLDER": "Szukaj autora"
        },
        "META_TITLE": {
          "LABEL": "Tytuł meta",
          "PLACEHOLDER": "Dodaj tytuł meta"
        },
        "META_DESCRIPTION": {
          "LABEL": "Opis meta",
          "PLACEHOLDER": "Dodaj opis meta dla lepszych wyników SEO..."
        },
        "META_TAGS": {
          "LABEL": "Tagi meta",
          "PLACEHOLDER": "Dodaj tagi meta oddzielone przecinkami..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Archiwizuj artykuł",
        "DELETE": "Usuń artykuł"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Bez kategorii",
      "SEARCH_RESULTS": "Wyniki wyszukiwania dla {query}",
      "EMPTY_TEXT": "Wyszukaj artykuły, aby wstawić je do odpowiedzi.",
      "SEARCH_LOADER": "Wyszukiwanie...",
      "INSERT_ARTICLE": "Wstaw",
      "NO_RESULT": "Brak znalezionych artykułów",
      "COPY_LINK": "Skopiuj link do artykułu do schowka",
      "OPEN_LINK": "Otwórz artykuł w nowej karcie",
      "PREVIEW_LINK": "Podgląd artykułu"
    },
    "PORTAL": {
      "HEADER": "Portale",
      "DEFAULT": "Domyślny",
      "NEW_BUTTON": "Nowy portal",
      "ACTIVE_BADGE": "aktywna",
      "CHOOSE_LOCALE_LABEL": "Wybierz język",
      "LOADING_MESSAGE": "Ładowanie portalów...",
      "ARTICLES_LABEL": "artykułów",
      "NO_PORTALS_MESSAGE": "Brak dostępnych portali",
      "ADD_NEW_LOCALE": "Dodaj nowy język",
      "POPOVER": {
        "TITLE": "Portale",
        "PORTAL_SETTINGS": "Ustawienia portalu",
        "SUBTITLE": "Masz wiele portali i możesz mieć różne języki dla każdego z nich.",
        "CANCEL_BUTTON_LABEL": "Anuluj",
        "CHOOSE_LOCALE_BUTTON": "Wybierz język"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "artykułów",
            "ADD": "Dodaj język",
            "VISIT": "Odwiedź stronę",
            "SETTINGS": "Ustawienia",
            "DELETE": "Usuń"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Konfiguracje portalu",
            "ITEMS": {
              "NAME": "Nazwa",
              "DOMAIN": "Niestandardowa domena",
              "SLUG": "Slug",
              "TITLE": "Tytuł portalu",
              "THEME": "Kolor motywu",
              "SUB_TEXT": "Tekst dodatkowy portalu"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Dostępne języki",
            "TABLE": {
              "NAME": "Nazwa języka",
              "CODE": "Kod języka",
              "ARTICLE_COUNT": "Liczba artykułów",
              "CATEGORIES": "Liczba kategorii",
              "SWAP": "Zamień",
              "DELETE": "Usuń",
              "DEFAULT_LOCALE": "Domyślny"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Usuń portal",
          "MESSAGE": "Czy na pewno chcesz usunąć ten portal",
          "YES": "Tak, usuń portal",
          "NO": "Nie, zachowaj portal",
          "API": {
            "DELETE_SUCCESS": "Portal został pomyślnie usunięty",
            "DELETE_ERROR": "Błąd podczas usuwania portalu"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Edytuj portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Podstawowe informacje"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Dostosowanie portalu"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorie"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Języki"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorie w",
          "NEW_CATEGORY": "Nowa kategoria",
          "TABLE": {
            "NAME": "Nazwa",
            "DESCRIPTION": "Opis",
            "LOCALE": "Język",
            "ARTICLE_COUNT": "Liczba artykułów",
            "ACTION_BUTTON": {
              "EDIT": "Edytuj kategorię",
              "DELETE": "Usuń kategorię"
            },
            "EMPTY_TEXT": "Nie znaleziono kategorii"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Zaktualizuj podstawowe ustawienia"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informacje o centrum pomocy",
            "BODY": "Podstawowe informacje o portalu"
          },
          "CUSTOMIZATION": {
            "TITLE": "Dostosowanie centrum pomocy",
            "BODY": "Dostosuj portal"
          },
          "FINISH": {
            "TITLE": "Gotowe! 🎉",
            "BODY": "Wszystko jest gotowe!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Powrót",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Utwórz portal",
            "TITLE": "Informacje o centrum pomocy",
            "CREATE_BASIC_SETTING_BUTTON": "Utwórz podstawowe ustawienia portalu"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Dostosowanie portalu",
            "TITLE": "Dostosowanie centrum pomocy",
            "UPDATE_PORTAL_BUTTON": "Zaktualizuj ustawienia portalu"
          },
          "FINISH_PAGE": {
            "TITLE": "Gotowe!🎉 Wszystko jest gotowe!",
            "MESSAGE": "Możesz teraz zobaczyć utworzony portal na stronie z wszystkimi portalami.",
            "FINISH": "Przejdź do strony z wszystkimi portalami"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Prześlij logo",
          "HELP_TEXT": "To logo będzie wyświetlane w nagłówku portalu.",
          "IMAGE_UPLOAD_SUCCESS": "Logo zostało pomyślnie przesłane",
          "IMAGE_UPLOAD_ERROR": "Logo zostało pomyślnie usunięte",
          "IMAGE_DELETE_ERROR": "Błąd podczas usuwania logo"
        },
        "NAME": {
          "LABEL": "Nazwa",
          "PLACEHOLDER": "Nazwa portalu",
          "HELP_TEXT": "Nazwa będzie używana w publicznym portalu wewnętrznie.",
          "ERROR": "Nazwa jest wymagana"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portalu dla adresów URL",
          "ERROR": "Slug jest wymagany"
        },
        "DOMAIN": {
          "LABEL": "Niestandardowa domena",
          "PLACEHOLDER": "Niestandardowa domena portalu",
          "HELP_TEXT": "Dodaj tylko, jeśli chcesz używać niestandardowej domeny dla swoich portali. Np.: {exampleURL}",
          "ERROR": "Podaj poprawny adres URL domeny"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link do strony głównej",
          "PLACEHOLDER": "Link do strony głównej portalu",
          "HELP_TEXT": "Link używany do powrotu z portalu na stronę główną. Np.: {exampleURL}",
          "ERROR": "Podaj poprawny adres URL strony głównej"
        },
        "THEME_COLOR": {
          "LABEL": "Kolor motywu portalu",
          "HELP_TEXT": "Ten kolor będzie widoczny jako kolor motywu portalu."
        },
        "PAGE_TITLE": {
          "LABEL": "Tytuł strony",
          "PLACEHOLDER": "Tytuł strony portalu",
          "HELP_TEXT": "Tytuł strony będzie używany w publicznym portalu.",
          "ERROR": "Tytuł strony jest wymagany"
        },
        "HEADER_TEXT": {
          "LABEL": "Tekst nagłówka",
          "PLACEHOLDER": "Tekst nagłówka portalu",
          "HELP_TEXT": "Tekst nagłówka portalu będzie używany w publicznym portalu.",
          "ERROR": "Tekst nagłówka portalu jest wymagany"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal utworzony pomyślnie.",
          "ERROR_MESSAGE_FOR_BASIC": "Nie udało się utworzyć portalu. Spróbuj ponownie.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal zaktualizowany pomyślnie.",
          "ERROR_MESSAGE_FOR_UPDATE": "Nie udało się zaktualizować portalu. Spróbuj ponownie."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Dodaj nowy język",
        "SUB_TITLE": "Dodaje nowy język do listy dostępnych tłumaczeń.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Język",
          "PLACEHOLDER": "Wybierz język",
          "ERROR": "Język jest wymagany"
        },
        "BUTTONS": {
          "CREATE": "Utwórz język",
          "CANCEL": "Anuluj"
        },
        "API": {
          "SUCCESS_MESSAGE": "Język dodany pomyślnie",
          "ERROR_MESSAGE": "Nie można dodać języka. Spróbuj ponownie."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Domyślny język zaktualizowany pomyślnie",
          "ERROR_MESSAGE": "Nie można zaktualizować domyślnego języka. Spróbuj ponownie."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Język usunięty z portalu pomyślnie",
          "ERROR_MESSAGE": "Nie można usunąć języka z portalu. Spróbuj ponownie."
        }
      }
    },
    "TABLE": {
      "404": "Nie znaleziono artykułów pasujących do wyszukiwania 🔍",
      "LOADING_MESSAGE": "Ładowanie artykułów...",
      "NO_ARTICLES": "Brak dostępnych artykułów",
      "HEADERS": {
        "TITLE": "Tytuł",
        "CATEGORY": "Kategoria",
        "READ_COUNT": "Wyświetlenia",
        "STATUS": "Status",
        "LAST_EDITED": "Ostatnio edytowane"
      },
      "COLUMNS": {
        "BY": "przez",
        "AUTHOR_NOT_AVAILABLE": "Autor jest niedostępny"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Ładowanie artykułu...",
      "TITLE_PLACEHOLDER": "Tutaj wprowadź tytuł artykułu",
      "CONTENT_PLACEHOLDER": "Napisz tutaj treść artykułu",
      "API": {
        "ERROR": "Błąd podczas zapisywania artykułu"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Błąd podczas publikowania artykułu",
        "SUCCESS": "Artykuł opublikowany pomyślnie"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Błąd podczas archiwizowania artykułu",
        "SUCCESS": "Artykuł zarchiwizowany pomyślnie"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Błąd podczas zmiany artykułu na Draft",
        "SUCCESS": "Artykuł zapisany jako Draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Potwierdź usunięcie",
          "MESSAGE": "Czy na pewno chcesz usunąć ten artykuł?",
          "YES": "Tak, usuń",
          "NO": "Nie, zachowaj"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artykuł pomyślnie usunięty",
        "ERROR_MESSAGE": "Błąd podczas usuwania artykułu"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Proszę dodać tytuł i treść artykułu, aby móc zaktualizować ustawienia"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Wyszukaj artykuły"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Utwórz kategorię",
        "SUB_TITLE": "Kategoria będzie używana w publicznym portalu do kategoryzacji artykułów.",
        "PORTAL": "Portal",
        "LOCALE": "Język",
        "NAME": {
          "LABEL": "Nazwa",
          "PLACEHOLDER": "Nazwa kategorii",
          "HELP_TEXT": "Nazwa i ikona kategorii będą używane w publicznym portalu do kategoryzowania artykułów.",
          "ERROR": "Nazwa jest wymagana"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorii dla adresów URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/pl-PL/categories/my-slug",
          "ERROR": "Slug jest wymagany"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Krótki opis kategorii.",
          "ERROR": "Opis jest wymagany"
        },
        "BUTTONS": {
          "CREATE": "Utwórz kategorię",
          "CANCEL": "Anuluj"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategoria utworzona pomyślnie",
          "ERROR_MESSAGE": "Nie można utworzyć kategorii"
        }
      },
      "EDIT": {
        "TITLE": "Edytuj kategorię",
        "SUB_TITLE": "Edycja kategorii spowoduje aktualizację kategorii w publicznym portalu.",
        "PORTAL": "Portal",
        "LOCALE": "Język",
        "NAME": {
          "LABEL": "Nazwa",
          "PLACEHOLDER": "Nazwa kategorii",
          "HELP_TEXT": "Nazwa i ikona kategorii będą używane w publicznym portalu do kategoryzowania artykułów.",
          "ERROR": "Nazwa jest wymagana"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorii dla adresów URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/pl-PL/categories/my-slug",
          "ERROR": "Slug jest wymagany"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Krótki opis kategorii.",
          "ERROR": "Opis jest wymagany"
        },
        "BUTTONS": {
          "CREATE": "Aktualizuj kategorię",
          "CANCEL": "Anuluj"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategoria zaktualizowana pomyślnie",
          "ERROR_MESSAGE": "Nie można zaktualizować kategorii"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategoria pomyślnie usunięta",
          "ERROR_MESSAGE": "Nie można usunąć kategorii"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Szukaj artykułów",
      "PLACEHOLDER": "Szukaj artykułów",
      "NO_RESULT": "Brak znalezionych artykułów",
      "SEARCHING": "Wyszukiwanie...",
      "SEARCH_BUTTON": "Szukaj",
      "INSERT_ARTICLE": "Wstaw link",
      "IFRAME_ERROR": "Adres URL jest pusty lub nieprawidłowy. Nie można wyświetlić zawartości.",
      "OPEN_ARTICLE_SEARCH": "Wstaw artykuł z centrum pomocy",
      "SUCCESS_ARTICLE_INSERTED": "Artykuł został pomyślnie wstawiony",
      "PREVIEW_LINK": "Podgląd artykułu",
      "CANCEL": "Zamknij",
      "BACK": "Powrót",
      "BACK_RESULTS": "Powrót do wyników"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centrum pomocy",
      "DESCRIPTION": "Twórz przyjazne dla użytkownika portale self-service. Pomóż swoim użytkownikom uzyskać dostęp do artykułów i wsparcia 24/7. Zaktualizuj swoją subskrypcję, aby włączyć tę funkcję.",
      "SELF_HOSTED_DESCRIPTION": "Twórz przyjazne dla użytkownika portale self-service. Pomóż swoim użytkownikom uzyskać dostęp do artykułów i wsparcia 24/7. Skontaktuj się z administratorem, aby włączyć tę funkcję.",
      "BUTTON": {
        "LEARN_MORE": "Dowiedz się więcej",
        "UPGRADE": "Ulepsz"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Wiele portali",
          "DESCRIPTION": "Twórz wiele portali centrum pomocy dla różnych produktów przy użyciu tego samego konta."
        },
        "LOCALES": {
          "TITLE": "Pełne wsparcie dla języków",
          "DESCRIPTION": "Zlokalizuj portal w swoim języku. Obsługujemy wszystkie języki i umożliwiamy tłumaczenie każdego artykułu."
        },
        "SEO": {
          "TITLE": "Projekt przyjazny dla SEO",
          "DESCRIPTION": "Dostosuj swoje tagi meta, aby poprawić widoczność w wyszukiwarkach dzięki naszym stronom przyjaznym dla SEO."
        },
        "API": {
          "TITLE": "Pełne wsparcie API",
          "DESCRIPTION": "Używaj portalu jako headless CMS z zewnętrznymi frameworkami front-endowymi za pomocą naszych API."
        }
      }
    },
    "LOADING": "Ładowanie...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} wyświetlenie | {count} wyświetleń",
          "DROPDOWN_MENU": {
            "PUBLISH": "Opublikuj",
            "DRAFT": "Draft",
            "ARCHIVE": "Archiwizuj",
            "DELETE": "Usuń"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Opublikowane",
            "ARCHIVED": "Zarchiwizowane"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Bez kategorii"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Wszystkie artykuły",
          "MINE": "Moje",
          "DRAFT": "Draft",
          "PUBLISHED": "Opublikowane",
          "ARCHIVED": "Zarchiwizowane"
        },
        "CATEGORY": {
          "ALL": "Wszystkie kategorie"
        },
        "LOCALE": {
          "ALL": "Wszystkie języki"
        },
        "NEW_ARTICLE": "Nowy artykuł"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Napisz artykuł",
          "SUBTITLE": "Napisz rozbudowany artykuł, zacznijmy!",
          "BUTTON_LABEL": "Nowy artykuł"
        },
        "MINE": {
          "TITLE": "Nie napisałeś tu jeszcze żadnych artykułów",
          "SUBTITLE": "Wszystkie napisane przez Ciebie artykuły pojawiają się tutaj dla szybkiego dostępu."
        },
        "DRAFT": {
          "TITLE": "Brak artykułów w Draft",
          "SUBTITLE": "Artykuły Draft pojawią się tutaj"
        },
        "PUBLISHED": {
          "TITLE": "Brak opublikowanych artykułów",
          "SUBTITLE": "Opublikowane artykuły pojawią się tutaj"
        },
        "ARCHIVED": {
          "TITLE": "Brak artykułów w archiwum",
          "SUBTITLE": "Zarchiwizowane artykuły nie są widoczne w portalu, możesz ich używać do oznaczania przestarzałych lub nieaktualnych stron"
        },
        "CATEGORY": {
          "TITLE": "Brak artykułów w tej kategorii",
          "SUBTITLE": "Artykuły z tej kategorii pojawią się tutaj"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nowa kategoria",
        "EDIT_CATEGORY": "Edytuj kategorię",
        "CATEGORIES_COUNT": "{n} kategoria | {n} kategorii",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategorie ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} artykułów) | {categoryName} ({categoryCount} artykuł)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nie znaleziono kategorii",
        "SUBTITLE": "Kategorie pojawią się tutaj. Możesz dodać kategorię, klikając przycisk 'Nowa kategoria'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} artykuł | {count} artykułów",
        "EXPAND": "Pokaż podkategorie",
        "COLLAPSE": "Ukryj podkategorie",
        "MENU": {
          "NEW_ARTICLE": "Nowy artykuł",
          "ADD_SUBCATEGORY": "Dodaj podkategorię",
          "EDIT": "Edytuj",
          "DELETE": "Usuń"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria utworzona pomyślnie",
            "ERROR_MESSAGE": "Nie można utworzyć kategorii"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria zaktualizowana pomyślnie",
            "ERROR_MESSAGE": "Nie można zaktualizować kategorii"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria pomyślnie usunięta",
            "ERROR_MESSAGE": "Nie można usunąć kategorii"
          },
          "CONFIRM": {
            "TITLE": "Usuń kategorię",
            "DESCRIPTION": "Czy na pewno chcesz usunąć tę kategorię? Jej artykuły staną się nieskategoryzowane.",
            "DESCRIPTION_WITH_CHILDREN": "Czy na pewno chcesz usunąć tę kategorię? Jej artykuły staną się nieskategoryzowane, a jej {count} podkategoria zostanie przeniesiona na najwyższy poziom. | Czy na pewno chcesz usunąć tę kategorię? Jej artykuły staną się nieskategoryzowane, a jej {count} podkategorie zostaną przeniesione na najwyższy poziom.",
            "CONFIRM": "Usuń"
          }
        },
        "HEADER": {
          "CREATE": "Utwórz kategorię",
          "EDIT": "Edytuj kategorię",
          "DESCRIPTION": "Edycja kategorii spowoduje aktualizację kategorii w publicznym portalu.",
          "PORTAL": "Portal",
          "LOCALE": "Język"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Nazwa",
            "PLACEHOLDER": "Nazwa kategorii",
            "ERROR": "Nazwa jest wymagana"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug kategorii dla adresów URL",
            "ERROR": "Slug jest wymagany",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Opis",
            "PLACEHOLDER": "Krótki opis kategorii.",
            "ERROR": "Opis jest wymagany"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Kategoria nadrzędna",
            "PLACEHOLDER": "Wybierz kategorię nadrzędną",
            "NONE": "Brak (poziom najwyższy)"
          }
        },
        "BUTTONS": {
          "CREATE": "Utwórz",
          "EDIT": "Aktualizuj",
          "CANCEL": "Anuluj"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Brak dostępnych języków | {n} język | {n} języków",
      "NEW_LOCALE_BUTTON_TEXT": "Nowy język",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} artykuł | {count} artykułów",
        "CATEGORIES_COUNT": "{count} kategoria | {count} kategorii",
        "DEFAULT": "Domyślny",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Ustaw jako domyślny",
          "DELETE": "Usuń"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Dodaj nowy język",
        "DESCRIPTION": "Wybierz język, w którym będzie napisany ten artykuł. Zostanie on dodany do listy Twoich tłumaczeń, a więcej możesz dodać później.",
        "COMBOBOX": {
          "PLACEHOLDER": "Wybierz język..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Język dodany pomyślnie",
          "ERROR_MESSAGE": "Nie można dodać języka. Spróbuj ponownie."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Zapisywanie...",
          "SAVED": "Zapisano"
        },
        "PREVIEW": "Podgląd",
        "PUBLISH": "Opublikuj",
        "DRAFT": "Draft",
        "ARCHIVE": "Archiwizuj",
        "BACK_TO_ARTICLES": "Powrót do artykułów"
      },
      "DRAFT": {
        "PENDING_LABEL": "Niezapisane zmiany",
        "PROMOTE": "Opublikuj zmiany",
        "DISCARD": "Odrzuć zmiany",
        "PROMOTE_SUCCESS": "Zmiany Draft zostały opublikowane w aktywnej wersji artykułu",
        "PROMOTE_ERROR": "Nie udało się opublikować zmian Draft",
        "DISCARD_SUCCESS": "Zmiany Draft zostały odrzucone",
        "DISCARD_ERROR": "Nie udało się odrzucić zmian Draft"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Historia wersji",
        "TITLE": "Historia wersji",
        "BACK": "Powrót do artykułu",
        "LOADING": "Ładowanie wersji...",
        "EMPTY": "Brak wersji. Zmiany w tym artykule będą się tutaj pojawiać.",
        "EMPTY_CONTENT": "Ta wersja nie zawiera treści.",
        "CURRENT_BADGE": "Bieżąca",
        "RESTORED_BADGE": "Przywrócona",
        "AUTOMATED_USER": "Aktualizacja automatyczna",
        "RESTORE": "Przywróć tę wersję",
        "RESTORE_DIALOG": {
          "TITLE": "Przywrócić tę wersję?",
          "DESCRIPTION": "Artykuł wróci do treści z tej wersji. Nic nie zostanie utracone — bieżąca treść pozostanie w historii, a opublikowany artykuł nadal będzie wyświetlał aktywną wersję, dopóki nie opublikujesz zmiany.",
          "CONFIRM": "Przywróć"
        },
        "RESTORE_SUCCESS": "Wersja została przywrócona",
        "RESTORE_ERROR": "Nie udało się przywrócić tej wersji",
        "FETCH_ERROR": "Nie udało się wczytać historii wersji"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Więcej właściwości",
        "TRANSLATE": "Przetłumacz",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Bez kategorii",
        "EDITOR_PLACEHOLDER": "Napisz coś...",
        "HTML_EMBED": {
          "TITLE": "Wstaw niestandardowy HTML",
          "DESCRIPTION": "Wklej surowy kod HTML, taki jak iframe, osadzenie lub fragment widżetu. Zostanie wyświetlony bez zmian w opublikowanym artykule.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Wstaw"
        },
        "PRIMARY_CATEGORY": "Kategoria główna"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Właściwości artykułu",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Opis meta",
        "META_DESCRIPTION_PLACEHOLDER": "Dodaj opis meta",
        "META_TITLE": "Tytuł meta",
        "META_TITLE_PLACEHOLDER": "Dodaj tytuł meta",
        "META_TAGS": "Tagi meta",
        "META_TAGS_PLACEHOLDER": "Dodaj tagi meta",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Mutacje językowe",
        "LANGUAGE_MUTATIONS_EMPTY": "Brak powiązanych artykułów",
        "ADD_MUTATION": "Dodaj",
        "REMOVE_MUTATION": "Usuń"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Powiąż mutacje językowe",
        "SEARCH_PLACEHOLDER": "Szukaj artykułów po tytule",
        "EMPTY": "Brak pasujących artykułów",
        "CANCEL": "Anuluj",
        "ADD_SELECTED": "Dodaj wybrane",
        "SUCCESS": "Mutacje zaktualizowane",
        "ERROR": "Nie udało się zaktualizować mutacji"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Przetłumacz artykuł",
        "DESCRIPTION": "Wybierz języki, na które chcesz przetłumaczyć ten artykuł. Języki, które są już przetłumaczone, zostaną ponownie przetłumaczone do wersji Draft w celu przeglądu.",
        "EMPTY": "Nie są dostępne inne języki.",
        "CONNECTED_BADGE": "Przetłumaczone",
        "CANCEL": "Anuluj",
        "TRANSLATE": "Przetłumacz",
        "SUCCESS": "Tłumaczenie rozpocznie się wkrótce. Przetłumaczone artykuły wkrótce pojawią się jako wersje językowe.",
        "ERROR": "Nie udało się rozpocząć tłumaczenia"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Błąd podczas zapisywania artykułu"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Nowy portal",
      "PORTALS": "Portale",
      "CREATE_PORTAL": "Twórz i zarządzaj wieloma portalami",
      "ARTICLES": "artykułów",
      "DOMAIN": "domena",
      "PORTAL_NAME": "Nazwa portalu"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Utwórz nowy portal",
      "DESCRIPTION": "Nadaj swojemu portalowi nazwę i utwórz przyjazny dla użytkownika slug URL. Oba te elementy możesz później zmienić w ustawieniach.",
      "CONFIRM_BUTTON_LABEL": "Utwórz",
      "NAME": {
        "LABEL": "Nazwa",
        "PLACEHOLDER": "Podręcznik użytkownika",
        "MESSAGE": "Wybierz nazwę dla swojego portalu.",
        "ERROR": "Nazwa jest wymagana"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug jest wymagany",
        "FORMAT_ERROR": "Używaj tylko liter, cyfr i myślników, na przykład: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Nie udało się przesłać obrazu! Spróbuj ponownie",
          "IMAGE_UPLOAD_SUCCESS": "Obraz został pomyślnie dodany. Kliknij zapisz zmiany, aby zapisać logo",
          "IMAGE_DELETE_SUCCESS": "Logo zostało pomyślnie usunięte",
          "IMAGE_DELETE_ERROR": "Nie można usunąć logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "Rozmiar obrazu powinien być mniejszy niż {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Nazwa",
          "PLACEHOLDER": "Nazwa portalu",
          "ERROR": "Nazwa jest wymagana"
        },
        "HEADER_TEXT": {
          "LABEL": "Tekst nagłówka",
          "PLACEHOLDER": "Tekst nagłówka portalu"
        },
        "PAGE_TITLE": {
          "LABEL": "Tytuł strony",
          "PLACEHOLDER": "Tytuł strony portalu"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link do strony głównej",
          "PLACEHOLDER": "Link do strony głównej portalu",
          "ERROR": "Nieprawidłowy adres URL. Link do strony głównej musi zaczynać się od 'http://' lub 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widżet czatu na żywo",
          "PLACEHOLDER": "Wybierz widżet czatu na żywo",
          "HELP_TEXT": "Wybierz widżet czatu na żywo, który pojawi się w Twoim centrum pomocy"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Dostęp publiczny",
          "HELP_TEXT": "Udostępnij portal wszystkim z linkiem.",
          "OPTIONS": {
            "PUBLIC": "Tak",
            "PRIVATE": "Nie"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Cel odnośnika",
          "HELP_TEXT": "Wybierz, czy odnośniki w artykułach otwierają się w bieżącym oknie, czy w nowym.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Bieżące okno",
            "NEW_WINDOW": "Nowe okno"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Domyślny rozmiar obrazu",
          "HELP_TEXT": "Rozmiar stosowany do każdego obrazu wstawianego do artykułu. Wybierz Oryginalny, aby wstawiać obrazy w ich własnym rozmiarze i zamiast tego wybierać rozmiar dla każdego obrazu z osobna."
        },
        "BRAND_COLOR": {
          "LABEL": "Kolor marki"
        },
        "CUSTOM_HTML": {
          "LABEL": "Niestandardowy HTML",
          "PLACEHOLDER": "<!-- Wklej tutaj swój fragment kodu analitycznego lub śledzącego -->",
          "HELP_TEXT": "Wstawiane na początku znacznika <body> na każdej stronie centrum pomocy. Użyj go dla Google Analytics, Google Tag Manager lub innego fragmentu kodu śledzącego. Kod jest wyświetlany dokładnie tak, jak został wprowadzony, i nie jest walidowany."
        },
        "SAVE_CHANGES": "Zapisz zmiany"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Niestandardowa domena",
          "LABEL": "Niestandardowa domena:",
          "DESCRIPTION": "Możesz hostować swój portal na niestandardowej domenie. Na przykład, jeśli Twoja strona to yourdomain.com, a chcesz, aby Twój portal był dostępny pod adresem docs.yourdomain.com, po prostu wpisz to w tym polu.",
          "PLACEHOLDER": "Niestandardowa domena portalu",
          "EDIT_BUTTON": "Edytuj niestandardową domenę",
          "ADD_BUTTON": "Dodaj niestandardową domenę",
          "DIALOG": {
            "ADD_HEADER": "Dodaj niestandardową domenę",
            "EDIT_HEADER": "Edytuj niestandardową domenę",
            "ADD_CONFIRM_BUTTON_LABEL": "Dodaj domenę",
            "EDIT_CONFIRM_BUTTON_LABEL": "Zaktualizuj domenę",
            "LABEL": "Niestandardowa domena",
            "PLACEHOLDER": "Niestandardowa domena portalu",
            "ERROR": "Niestandardowa domena jest wymagana"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Konfiguracja DNS",
            "DESCRIPTION": "Zaloguj się na konto u swojego dostawcy DNS i dodaj poniższy rekord CNAME dla swojej subdomeny.",
            "HELP_TEXT": "Po wykonaniu tej czynności możesz skontaktować się z naszym wsparciem, aby poprosić o automatycznie wygenerowany certyfikat SSL.",
            "CONFIRM_BUTTON_LABEL": "Zrozumiałem!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Usuń {portalName}",
          "HEADER": "Usuń portal",
          "DESCRIPTION": "Trwale usuń ten portal. Ta czynność jest nieodwracalna",
          "DIALOG": {
            "HEADER": "Czy na pewno chcesz usunąć {portalName}?",
            "DESCRIPTION": "To jest trwała czynność, której nie można cofnąć.",
            "CONFIRM_BUTTON_LABEL": "Usuń"
          }
        },
        "EDIT_CONFIGURATION": "Edytuj konfigurację"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal utworzony pomyślnie",
          "ERROR_MESSAGE": "Nie można utworzyć portalu"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal zaktualizowany pomyślnie",
          "ERROR_MESSAGE": "Nie można zaktualizować portalu"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Załączniki",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Dodaj plik",
      "DROP_HERE": "Przeciągnij i upuść pliki tutaj",
      "COPY_LINK": "Kopiuj link",
      "LINK_COPIED": "Link skopiowany do schowka",
      "COPY_FAILED": "Nie udało się skopiować linku",
      "DELETE": "Usuń",
      "CANCEL": "Anuluj",
      "QUEUED": "W kolejce",
      "UPLOADING": "Przesyłanie",
      "UPLOAD_FAILED": "Nie udało się przesłać pliku",
      "FILE_TOO_LARGE": "Plik przekracza limit rozmiaru 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Słownik tłumaczeń",
        "DESCRIPTION": "Terminy zdefiniowane tutaj są dodawane do polecenia tłumaczenia AI, dzięki czemu są zawsze tłumaczone w ten sam sposób. Termin główny jest zapisany w języku {locale}."
      },
      "NEW_TERM": "Nowy termin",
      "EMPTY_STATE": {
        "TITLE": "Brak terminów w słowniku",
        "SUBTITLE": "Dodaj termin i jego tłumaczenie dla każdego języka. Podczas tłumaczenia artykułu te terminy są egzekwowane, dzięki czemu nazewnictwo Twojego produktu pozostaje spójne."
      },
      "LIST": {
        "TERM": "Termin",
        "TRANSLATIONS": "Tłumaczenia",
        "ACTIONS": "Akcje"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Dodaj termin",
          "EDIT": "Edytuj termin",
          "DESCRIPTION": "Poniższy termin jest egzekwowany podczas tłumaczenia artykułów centrum pomocy przez AI.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Język główny"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Termin ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Termin jest wymagany"
          },
          "DESCRIPTION": {
            "LABEL": "Kontekst / uwagi (opcjonalnie)",
            "PLACEHOLDER": "Kiedy i jak używany jest ten termin, aby pomóc tłumaczowi w jednoznacznej interpretacji."
          },
          "TRANSLATIONS": "Tłumaczenia",
          "TRANSLATION_PLACEHOLDER": "Pozostaw puste, aby AI tłumaczyło swobodnie",
          "AUTO_TRANSLATE": {
            "BUTTON": "Przetłumacz automatycznie wszystko",
            "CONFIRM": "Przetłumaczyć na {count} języków za pomocą AI?",
            "CONFIRM_BUTTON": "Przetłumacz",
            "CANCEL": "Anuluj",
            "SUCCESS": "Wygenerowano tłumaczenia — sprawdź i zapisz",
            "ERROR": "Nie udało się automatycznie przetłumaczyć, spróbuj ponownie"
          }
        },
        "BUTTONS": {
          "CREATE": "Dodaj termin",
          "EDIT": "Zapisz",
          "CANCEL": "Anuluj"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Termin dodany pomyślnie",
            "ERROR_MESSAGE": "Nie można dodać terminu, spróbuj ponownie"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Termin zaktualizowany pomyślnie",
            "ERROR_MESSAGE": "Nie można zaktualizować terminu, spróbuj ponownie"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Usuń termin",
          "DESCRIPTION": "Czy na pewno chcesz usunąć ten termin? Nie będzie już egzekwowany podczas tłumaczenia.",
          "CONFIRM": "Usuń"
        },
        "API": {
          "SUCCESS_MESSAGE": "Termin pomyślnie usunięty",
          "ERROR_MESSAGE": "Nie można usunąć terminu, spróbuj ponownie"
        }
      }
    }
  }
}
